export default __webpack_public_path__ + "images/mela-purchase/getadditional-math-56d37c1067fc57e9b0ad796719f2cd90.svg";